module.exports = __webpack_public_path__ + "img/img_wait_clean_king.133d5939.png";